/**
 * Author:XCL
 *
 * Time:2016-01-11
 */
'use strict';
angular.module('ediCtrNewspaperShangbanModule', []).controller('ediCtrNewspaperShangbanCtrl', [
    '$scope',
    '$timeout',
    '$modalInstance',
    '$validation',
    '$stateParams',
    '$filter',
    'trsHttpService',
    'transferData',
    'trsspliceString',
    'modalDialog',
    'iwoNoticeService',
    function ($scope, $timeout, $modalInstance, $validation, $stateParams, $filter, trsHttpService, transferData, trsspliceString, modalDialog, iwoNoticeService) {
        initStatus();
        initData();

        /**
         * [initStatus description] 初始化状态
         * @return  {[type]}  [return description]
         */
        function initStatus() {
            $scope.params = {
                serviceid: 'mlf_paper',
            };
            $scope.status = {
                draftFrom: {
                    29: '归档稿',
                    30: '今日稿',
                    31: '待用稿',
                    32: '今日稿',
                    33: '今日稿',
                    34: '上版稿',
                    35: '已签稿',
                    36: '已签稿',
                    37: '已签稿',
                    38: '已签稿',
                },
                isRequeted: false,
                banmianType: transferData.banmianMethodName && transferData.banmianMethodName === 'queryZhaoPaiBanMians' ? '照排' : '采编',
            };
            $scope.data = {
                canDesignatedAuditor: transferData.canDesignatedAuditor, // 是否允许指定审核人，现在只有上版有，转版没有
                selectedRelatedDraft: [],
                currItem: angular.copy(transferData.selectedArr),
                customConfig: {
                    singleDatePicker: true, // 是否是单选框
                },
                selected: {}
            };
            $scope.title = transferData.title;
            $scope.opinionTit = transferData.opinionTit;
            $scope.items = transferData.selectedArr;
            $scope.choosedManuCount = transferData.selectedArr.length;
            $scope.isShowDate = transferData.isShowDate;
            $scope.relatedContent = false;
            $scope.selectedDieci = '';
            $scope.selectedCaibian = '';
            $scope.manuInfos = {
                caibian: '',
                dieci: '',
            };
            $scope.isManusCorrShow = false;
            $scope.hasNoManusCorr = false;
            $scope.clickCurrItem = '';
            $scope.params = {
                serviceid: 'mlf_paper',
                PaperId: transferData.PaperId || transferData.selectedArr[0].SITEID,
                SrcDocId: transferData.SrcDocId,
            };
            getFlexContentH();
        }

        /**
         * [handleTitle description] 处理标题
         * @param {object} [item] [description] 列表数据
         * @return {[type]} [description]
         */
        $scope.handleTitle = function (item) {
            item.TITLE = $('<div>' + item.TITLE + '</div>').text();
        };

        /** [getFlexContentH description]根据body的高度来给弹性布局的主题设置高度 */
        function getFlexContentH() {
            $timeout(function () {
                var height = document.getElementsByClassName('shangban-body-left')[0].offsetHeight;
                document.getElementsByClassName('flexContent')[0].style.height = height + 'px';
            }, 500);
        }

        /**
         * [initData description] 初始化数据
         * @return  {[type]}  [return description]
         */
        function initData() {
            // 获取当前日期的后一天
            // Date():返回当日的时间和日期
            // getDate():从Date对象返回一个月中的某一天(1 ~ 31)
            // setDate():设置Date对象中月的某一天
            getDiecis();
            getSelectedManuDetail();
            getPubDate();
        }

        /**
         * [getPubDate description] 处理时间
         * @return  {[type]}  [return description]
         */
        function getPubDate() {
        	if(new Date($scope.items[0].PUBDATE).getTime() > new Date().getTime()){
        		$scope.status.date = $scope.items[0].PUBDATE;
        	}else {
        		var time = Number($filter('date')(new Date(), 'HH'));
	            // 如果系统时间大于8点了,就显示第二天上版
	            if (time > 8) {
	                $scope.status.date = new Date().setDate(new Date().getDate() + 1);
	            } else {
	                // 小于8点,就显示当天上版
	                $scope.status.date = new Date().setDate(new Date().getDate());
	            }
        	}
            // $scope.status.date = angular.isDefined($scope.items[0].PUBDATE) && $scope.items.length > 4 ? $scope.items[0].PUBDATE : new Date().setDate(new Date().getDate() + 1);
        }

        $scope.cancel = function () {
            $modalInstance.close(false);
        };

        /**
         * [manuscriptCorrelationData description] 显示稿件关联方法
         * @param   {[type]}  item  [item description]
         * @return  {[type]}        [return description]
         */
        function manuscriptCorrelationData(item) {
            var methodnameObj = {
                '29': 'queryReleteDocsInGuiDang',
                '30': 'queryRelateDocsInJinRi',
                '31': 'queryRelateDocsInDaiYong',
                '32': 'queryRelateDocsInJinRi',
                '33': 'queryRelateDocsInJinRi',
                '34': 'queryRelateDocsInShangBan',
            };
            $scope.params.methodname = methodnameObj[item.DOCSTATUS];
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), $scope.params, 'get').then(function (data) {
                $scope.relationDraft = data.filter(function (item) {
                    return item.DOCSTATUS !== '35';
                });
                $scope.data.selectedRelatedDraft = [];
                for (var i = 0; i < data.length; i++) {
                    for (var j in $scope.items) {
                        if ($scope.items[j].RECID === data[i].RECID) {
                            $scope.data.selectedRelatedDraft.push(data[i]);
                        }
                    }
                }
                $scope.hasNoManusCorr = data == '';
            });
        }
        // 显示稿件关联
        $scope.ManusCorrToggle = function (id, item) {
            $scope.selectedItem = item;
            if ($scope.clickCurrItem == '' || $scope.clickCurrItem != id) {
                $scope.isManusCorrShow = true;
                $scope.clickCurrItem = id;
            } else if ($scope.clickCurrItem == id) {
                $scope.isManusCorrShow = false;
                $scope.clickCurrItem = '';
            }
            $scope.params.SrcDocId = id;
            manuscriptCorrelationData(item);
        };
        // 删除
        $scope.singleDel = function (curItem, item) {
            var flag = false;
            $scope.data.currItem.forEach(function (value, index, arr) {
                if (value.RECID == item.RECID) {
                    flag = true;
                    return;
                }
            });
            flag ? $scope.items.splice(curItem, 1) : $scope.chooseRelatedDraft(item);
            $scope.choosedManuCount = $scope.items.length;
            if ($scope.items.length === 0) {
                modalDialog.alertType('已选稿件为空', '', 'warning', false);
            }
        };

        /**
         * [getDiecis description] 获取叠次列表
         * @return  {[type]}  [return description]
         */
        function getDiecis() {
            var params = {
                serviceid: 'mlf_paper',
                methodname: 'queryDieCis',
                PaperId: $stateParams.paperid || transferData.selectedArr[0].SITEID,
            };
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function (data) {
                $scope.dieciItems = data;
            });
        }

        // 确定
        $scope.confirm = function () {
            $scope.status.isRequeted = true;
            var dateStr = $filter('date')($scope.status.date, 'yyyy-MM-dd').toString();
            var option = $scope.option;
            var returnData = {
                srcdocids: trsspliceString.spliceString($scope.items, 'METADATAID', ','),
                srcChnldocIds: trsspliceString.spliceString($scope.items, 'CHNLDOCID', ','),
                dateStr: dateStr,
                option: option,
                banmianid: $scope.selectedCaibian,
                selected: $scope.data.selected
            };
            (returnData.SrcBanMianIds = angular.isDefined($scope.items[0].CHNLID)
                ? trsspliceString.spliceString($scope.items, 'CHNLID', ',')
                : trsspliceString.spliceString($scope.items, 'CHANNELID', ',')),
            $validation
                .validate($scope.shangbanForm)
                .success(function () {
                    if ($scope.selectedCaibian === '' || !$scope.selectedCaibian) {
                        modalDialog.alertType('提交失败', '请选择提交版面', 'warning', false, function () { });
                    } else {
                        $modalInstance.close(returnData);
                        $scope.items = '';
                    }
                })
                .error(function () {
                    modalDialog.alertType('提交失败', '请输入正确的数据格式', 'error', false, function () { });
                });
        };

        // 叠次选择切换相应的采编版面
        $scope.dieciClick = function (curItem) {
            $scope.manuInfos.caibian = '';
            $scope.selectedCaibian = '';
            $scope.dieciSelected = curItem;
            $scope.manuInfos.dieci = '';
            var dieciStr = trsspliceString.spliceString($scope.dieciItems, 'CHANNELID', ',');
            var dieciArray = dieciStr.split(',');
            $scope.selectedDieci = dieciArray[curItem];
            getCBLayout();
        };

        // 选择采编版面,获取版面id
        $scope.caibianClick = function (curItem, index) {
            $scope.caibianSelected = curItem;
            $scope.manuInfos.caibian = '';
            var caibianStr = trsspliceString.spliceString($scope.cbItems, 'CHANNELID', ',');
            var caibianArray = caibianStr.split(',');
            $scope.selectedCaibian = caibianArray[index];
        };

        /**
         * [getSelectedManuDetail description] 获取已选稿件详情
         * @return  {[type]}  [return description]
         */
        function getSelectedManuDetail() {
            var params = {
                serviceid: 'mlf_paper',
                methodname: 'queryViewDatas',
                MetaDataIds: $scope.items[0].METADATAID,
            };
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function (data) {
                $scope.manuInfos.dieci = data[0];
                $scope.manuInfos.caibian = data[0];
                $scope.selectedCaibian = $scope.items[0].CHANNELID === data[0].CHANNELID ? data[0].CHANNELID : '' ;
                var params = {
                    serviceid: 'mlf_paper',
                    methodname: transferData.banmianMethodName || 'queryCaiBianBanMians',
                    PaperId: $stateParams.paperid || transferData.selectedArr[0].SITEID,
                    DieCiId: data[0].DIECIID,
                };
                trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function (data) {
                    $scope.cbItems = data;
                    $timeout(function () {
                        $('.selectedItem')[0].scrollIntoView();
                    });
                });
            });
        }

        /**
         * [getCBLayout description] // 根据叠次名获取采编版面列表
         * @return  {[type]}  [return description]
         */
        function getCBLayout() {
            var params = {
                serviceid: 'mlf_paper',
                methodname: transferData.banmianMethodName || 'queryCaiBianBanMians',
                PaperId: $stateParams.paperid || transferData.selectedArr[0].SITEID,
                DieCiId: $scope.selectedDieci,
            };
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function (data) {
                $scope.cbItems = data;
            });
        }

        /** [chooseAllRelateDraft description]全选或者取消全选的操作 */
        $scope.chooseAllRelateDraft = function () {
            if ($scope.data.selectedRelatedDraft.length === $scope.relationDraft.length && $scope.relationDraft.length > 0) {
                $scope.data.selectedRelatedDraft = [];
                for (var i = 0; i < $scope.relationDraft.length; i++) {
                    for (var x in $scope.items) {
                        if ($scope.items[x].RECID === $scope.relationDraft[i].RECID) {
                            $scope.items.splice(x, 1);
                            break;
                        }
                    }
                }
            } else {
                $scope.data.selectedRelatedDraft = [];
                for (var j = 0; j < $scope.relationDraft.length; j++) {
                    $scope.data.selectedRelatedDraft.push($scope.relationDraft[j]);
                    var flag = true;
                    for (var y in $scope.items) {
                        if ($scope.items[y].RECID === $scope.relationDraft[j].RECID) {
                            flag = false;
                        }
                    }
                    if (flag) {
                        $scope.items.push($scope.relationDraft[j]);
                    }
                }
            }
        };
        // 选择相关联的稿件shangban
        $scope.chooseRelatedDraft = function (item) {
            if (item.DOCSTATUS === '35') {
                return;
            }
            var num = $scope.data.selectedRelatedDraft.indexOf(item),
                flag = true,
                num2;
            if (num === -1) {
                $scope.data.selectedRelatedDraft.push(item);
            } else {
                $scope.data.selectedRelatedDraft.splice(num, 1);
            }
            for (var i = 0; i < $scope.items.length; i++) {
                if ($scope.items[i].RECID === item.RECID) {
                    flag = false;
                    num2 = i;
                    break;
                } else {
                    flag = true;
                }
            }
            if (flag) {
                $scope.items.push(item);
            } else {
                $scope.items.splice(num2, 1);
            }
        };

        // 选择指定审核人
        $scope.selected = function() {
            iwoNoticeService.userAndDeptTransfer('', '', [], 0, [0, 1], '选择审核人').then(function(data) {
                $scope.data.selected = data;
                $scope.data.inputValue = data.selectedArray.map(function(item) {
                    return item.USERNAME || item.GNAME;
                }).join('、');
            });
        };
    },
]);
